import { render, staticRenderFns } from "./shortVideoManagement.vue?vue&type=template&id=f57f1f82&scoped=true&"
import script from "./shortVideoManagement.vue?vue&type=script&lang=js&"
export * from "./shortVideoManagement.vue?vue&type=script&lang=js&"
import style0 from "./shortVideoManagement.vue?vue&type=style&index=0&id=f57f1f82&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f57f1f82",
  null
  
)

export default component.exports